import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    currentModelEntityName: null,
    currentModelEntityNodeId: null,
    currentModelEntityVersion: null,
    isEnabledVersionGlobalPeriodChange: true
};
export const monitoringModelEntitySlice = createSlice({
    name: 'monitoringModelEntity',
    initialState,
    reducers: {
        setCurrentModelEntity: (state, action) => {
            state.currentModelEntityName = action.payload;
        },
        setCurrentModelEntityNodeId: (state, action) => {
            state.currentModelEntityNodeId = action.payload;
        },
        setCurrentModelEntityVersion: (state, action) => {
            state.currentModelEntityVersion = action.payload;
            state.isEnabledVersionGlobalPeriodChange = true;
        },
        setIsEnabledVersionGlobalPeriodChange: (state, action) => {
            state.isEnabledVersionGlobalPeriodChange = action.payload;
        },
        clearModelEntityState: () => initialState
    }
});
export const { setCurrentModelEntity, setCurrentModelEntityNodeId, setCurrentModelEntityVersion, setIsEnabledVersionGlobalPeriodChange, clearModelEntityState } = monitoringModelEntitySlice.actions;
export default monitoringModelEntitySlice.reducer;
